import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle, LanguageToggle } from "@/components/Toggles";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

/**
 * App-shell layout for the public marketing pages.
 * Slim mobile-app-style header, minimal footer (no long marketing lists).
 */
export const MarketingLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-[var(--so-bg)]" data-testid="marketing-layout">
      <header className="sticky top-0 z-40 bg-[var(--so-surface)] border-b border-[var(--so-border)]">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-14 flex items-center justify-between">
          <Link to="/" data-testid="nav-home"><Logo size={30} /></Link>
          <div className="flex items-center gap-1.5">
            <LanguageToggle />
            <ThemeToggle />
            {user ? (
              <>
                <button
                  onClick={() => navigate(
                    user.role === "customer" ? "/app" :
                    user.role === "restaurant_owner" ? "/restaurant" :
                    user.role === "rider" ? "/rider" : "/admin"
                  )}
                  data-testid="open-app-btn"
                  className="ml-2 inline-flex items-center justify-center rounded-full bg-[var(--so-orange)] hover:bg-[#EA580C] text-white text-sm font-bold px-4 h-9 transition-all active:scale-95"
                >
                  {t("openApp") || "Open App"}
                </button>
                <button
                  onClick={logout}
                  data-testid="logout-btn"
                  className="text-sm font-medium px-2 hover:text-[var(--so-orange)] hidden sm:inline-flex"
                >{t("logout")}</button>
              </>
            ) : null}
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-[var(--so-border)] py-6">
        <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--so-text-soft)]">
          <div className="flex items-center gap-2">
            <Logo size={22} withText={false} />
            <span>© 2026 ServeOn · Alena</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/business" className="hover:text-[var(--so-orange)] font-semibold" data-testid="footer-business-link">For Businesses</Link>
            <span className="hidden sm:inline">Sudan 🇸🇩</span>
          </div>
        </div>
      </footer>
    </div>
  );
};
